exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-6eed959c]{position:relative;overflow-y:auto;height:90vh}.table[data-v-6eed959c]{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:auto;margin-top:0;margin-bottom:0;width:100%;min-width:1290px}.table tr td[data-v-6eed959c]:last-child{cursor:pointer}.product-details-table[data-v-6eed959c]{margin-left:25px}.product-details-table td[data-v-6eed959c]{vertical-align:top;width:50%;margin-bottom:3px}", ""]);

// exports
